import {
  React,
  Component,
  helpers,
  PropTypes,
  axios,
  routes
} from 'imports/CommonImports';

import {
  PrimaryButton,
  AlertDialogOneButton,
} from 'imports/DesignImports';

import {
  DoneIcon,
} from 'imports/IconsImports';

import {
  Paper,
  TextField,
  LinearProgress,
} from 'material-ui';


const styles = {
  valueContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    marginLeft: '1em',
  },
  value: {
    marginBottom: '0',
  },
  valueName: {
    marginTop: '0',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '2em 0',
  },
  button: {
    marginTop: '1em'
  },
}
class InsertBAU extends Component {
  constructor(props){
    super(props);
    this.state = {
      bau: props.bau.map((bau) => bau.value),
    }
  }
  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <h1 style={styles.header}>Necesitas ingresar el valor del indicador actual ({this.props.indicator}) de la empresa para continuar (en {this.props.currency})</h1>
        </div>
        <div style={styles.valueContainer}>
          <table>
            <tbody>
              {this.props.years.map((year, i) => { 
                return <tr key={i}>
                  <th>{year.year}</th>
                  <td>
                    <TextField
                      hintText={year.year}
                      underlineStyle={styles.textFieldUnderline}
                      value={helpers.numberWithDots(this.state.bau[i])}
                      onChange={(event, newValue) => {this.handleChange(event, newValue, i)}}
                      inputStyle={styles.textFieldInput}
                      style={styles.textField}
                    />
                  </td>
                </tr>
              })}
            </tbody>
          </table>
          <div style={styles.buttonContainer}>
            {this.state.sendState === 'SENDING' && <LinearProgress style={{width: '60%'}}/>}
            {this.state.sendState === 'SUCCESS' &&
              <AlertDialogOneButton
                title='¡Éxito!'
                message= 'Tu indicador base a sido guardado con éxito'
                confirm={() => window.location.reload()} />
            }
            {this.state.sendState === 'ERROR' && <div>Error, intente de nuevo</div>}
            <PrimaryButton onClick={this.saveBAU} label="Enviar datos" style={styles.button}/>
          </div>
        </div>
      </Paper>
    );
  }

  handleChange = (event, newValue, index) => {
    var bau = this.state.bau;
    if(newValue === '')
      bau[index] = 0;
    else
      bau[index] = parseFloat(helpers.numberWithoutDots(newValue));
    this.setState({bau: bau});
  }

  saveBAU = () => {
    this.setState({sendState: 'SENDING'})
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    var data = {
      companyInfo: this.props.bau.map((bau, i) => {
        return {id: bau.id, BAUValue: this.state.bau[i], goalValue: null}
      })
    }
    connection.patch(routes.companyIndexInfo(this.props.user.company_id), data)
    .then((response) => {
      this.setState({sendState: 'SUCCESS'})
    })
    .catch((error) => {
      this.setState({sendState: 'ERROR'})
      console.error(error);
    })
  }
}

InsertBAU.propTypes = {
  style: PropTypes.object,
  token: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  currency: PropTypes.string,
  indicator: PropTypes.string,
  bau: PropTypes.array,
}

InsertBAU.defaultProps = {
  style: {},
  token: '',
  user: {},
  currency: 'CLP',
  indicator: 'EBITDA',
  bau: [0, 0, 0]
}

export default InsertBAU;



// WEBPACK FOOTER //
// ./src/components/dashboard/InsertBAU.js